import Background from 'src/assets/BuildAProject/6015061_8_11zon.avif'
import BackgroundTwo from 'src/assets/BuildAProject/3543015_4_11zon.avif'
import BackgroundTree from 'src/assets/BuildAProject/3680416_5_11zon.avif'
import BackgroundFour from 'src/assets/BuildAProject/3286718_3_11zon.avif'
import BackgroundFive from 'src/assets/BuildAProject/5442673_7_11zon.avif'
import BackgroundSix from 'src/assets/BuildAProject/4803959_6_11zon.avif'
import ProjectInitiationAndPlanning from 'src/assets/BuildAProject/projectinitiationandplanning_17_11zon.avif'
import DesignAndPrototyping from 'src/assets/BuildAProject/designandprototyping_11_11zon.avif'
import ProjectDevelopment from 'src/assets/BuildAProject/projectdevelopment_16_11zon.avif'
import QualitySystemTestingAndImplementation from 'src/assets/BuildAProject/qualitysystemtestingandimplementation_18_11zon.avif'
import LaunchingOfTheProject from 'src/assets/BuildAProject/launchingoftheproject_14_11zon.avif'
import ProjectAnalysis from 'src/assets/BuildAProject/projectanalysis_15_11zon.avif'
import {
    animationVariantsRightSuccess,
    animationVariantsSuccess,
} from 'src/theme/animations/swipeIn'
import { useTranslations } from 'src/provider/LocaleProvider'
import { BuildProjectLabels } from 'src/types'

export function BuildProjectLabels() {
    const t = useTranslations()
    const BuildProject: BuildProjectLabels[] = [
        {
            id: 1,
            phases: `${t('buildProject.phases.phaseOne.phases')}`,
            link: '#phase1',
            linkId: 'phase1',
            background: Background,
            title: `${t('buildProject.phases.phaseOne.title')}`,
            address: true,
            addressOver: 'row',
            image: ProjectInitiationAndPlanning,
            animation: animationVariantsSuccess,
            contentOneTitle: `${t('buildProject.phases.phaseOne.titleOne')}`,
            contentOne: `${t('buildProject.phases.phaseOne.contentOne')}`,
        },
        {
            id: 2,
            phases: `${t('buildProject.phases.phaseTwo.phases')}`,
            link: '#phase2',
            linkId: 'phase2',
            background: BackgroundTwo,
            title: `${t('buildProject.phases.phaseTwo.title')}`,
            address: false,
            addressOver: 'row',
            image: DesignAndPrototyping,
            animation: animationVariantsRightSuccess,
            contentOneTitle: `${t('buildProject.phases.phaseTwo.titleOne')}`,
            contentOne: `${t('buildProject.phases.phaseTwo.contentOne')}`,
            contentTwoTitle: `${t('buildProject.phases.phaseTwo.titleTwo')}`,
            contentTwo: `${t('buildProject.phases.phaseTwo.contentTwo')}`,
            contentTreeTitle: `${t('buildProject.phases.phaseTwo.titleTree')}`,
            contentTree: `${t('buildProject.phases.phaseTwo.contentTree')}`,
            contentFour: `${t('buildProject.phases.phaseTwo.contentFour')}`,
        },
        {
            id: 3,
            phases: `${t('buildProject.phases.phaseTree.phases')}`,
            link: '#phase3',
            linkId: 'phase3',
            background: BackgroundTree,
            title: `${t('buildProject.phases.phaseTree.title')}`,
            address: true,
            addressOver: 'column',
            image: ProjectDevelopment,
            animation: animationVariantsSuccess,
            contentOneTitle: `${t('buildProject.phases.phaseTree.titleOne')}`,
            contentOne: `${t('buildProject.phases.phaseTree.contentOne')}`,
            contentTwoTitle: `${t('buildProject.phases.phaseTree.titleTwo')}`,
            contentTwo: `${t('buildProject.phases.phaseTree.contentTwo')}`,
            contentTreeTitle: `${t('buildProject.phases.phaseTree.titleTree')}`,
            contentTree: `${t('buildProject.phases.phaseTree.contentTree')}`,
            contentFourTitle: `${t(
                'buildProject.phases.phaseTree.contentTree'
            )}`,
            contentFour: `${t('buildProject.phases.phaseTree.contentFour')}`,
        },
        {
            id: 4,
            phases: `${t('buildProject.phases.phaseFour.phases')}`,
            link: '#phase4',
            linkId: 'phase4',
            background: BackgroundFour,
            title: `${t('buildProject.phases.phaseFour.title')}`,
            address: false,
            addressOver: 'row-reverse',
            image: QualitySystemTestingAndImplementation,
            animation: animationVariantsRightSuccess,
            contentOne: `${t('buildProject.phases.phaseFour.contentOne')}`,
        },
        {
            id: 5,
            phases: `${t('buildProject.phases.phaseFive.phases')}`,
            link: '#phase5',
            linkId: 'phase5',
            background: BackgroundFive,
            title: `${t('buildProject.phases.phaseFive.title')}`,
            address: true,
            addressOver: 'row-reverse',
            image: LaunchingOfTheProject,
            animation: animationVariantsSuccess,
            contentOne: `${t('buildProject.phases.phaseFive.contentOne')}`,
        },
        {
            id: 6,
            phases: `${t('buildProject.phases.phaseSix.phases')}`,
            link: '#phase6',
            linkId: 'phase6',
            background: BackgroundSix,
            title: `${t('buildProject.phases.phaseSix.title')}`,
            address: false,
            addressOver: 'row-reverse',
            image: ProjectAnalysis,
            animation: animationVariantsRightSuccess,
            contentOne: `${t('buildProject.phases.phaseSix.contentOne')}`,
            contentTwo: `${t('buildProject.phases.phaseSix.contentTwo')}`,
        },
    ]
    return { BuildProject }
}
